export const TIMING = Object.freeze({
  UI: {
    START_UI_REVEAL: 1500,
    BLACKOUT_TIMER: 200,
    BLACKOUT_WAIT_TO_REVEAL: 50,
  },
  VIDEO: {
    VID_END_TIMER: 1500,
  },
});
export const ASSETS = Object.freeze({
  "view-1": {
    desktop:
      "https://cdn.prod.website-files.com/61e77b1e3ddfc76b6fe81446/69d6b6f5903fe11ad9dae0c6_Comps%20View-Start%20Shot%20(with%20comps).webp",
    mobile:
      "https://cdn.prod.website-files.com/61e77b1e3ddfc76b6fe81446/69d92e32e453b551eee2b623_Comps%20View-Start%20Shot-MP%20(with%20comps).webp",
  },
});
export const VIEW_START_END = Object.freeze({
  "view-1": {
    startTime: 0,
    endTime: 0,
  },
});
export const LOOP_SEQUENCE_VIDS = true;
